// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/close_modal_White.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./FreeTextDropdown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./FreeTextDropdownActive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./FreeTextCross.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Modal > div.window {
  border: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}

div.Modal > div.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(38, 40, 47, 0.75);
  z-index: 3000;
}
div.Modal > div.window {
  border: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  background-color: #FFF;
  position: fixed;
  max-height: calc(100% - 20px);
  right: auto;
  -webkit-box-shadow: 2px 2px 5px #5F6766;
          box-shadow: 2px 2px 5px #5F6766;
  overflow: auto;
  z-index: 3001;
}
div.Modal > div.window.fullscreen {
  width: 100% !important;
  left: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
}
div.Modal > div.window.fullscreen content {
  height: 100vh;
}
div.Modal > div.window.fullscreen footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #FFF;
}
div.Modal > div.window.extra-wide {
  width: 1167px;
  left: calc(50% - 583.5px);
}
div.Modal > div.window.wide {
  width: 900px;
  left: calc(50% - 450px);
}
div.Modal > div.window.medium {
  width: 650px;
  left: calc(50% - 325px);
}
div.Modal > div.window.small {
  width: 400px;
  left: calc(50% - 200px);
}
div.Modal > div.window a.Button.close {
  top: 10px;
  right: 10px;
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: 20px;
  height: 20px;
  width: 20px;
  border: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  color: #FFF;
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 13px;
  font-family: sans-serif;
  z-index: 1010;
  cursor: pointer;
}
div.Modal > div.window div.header {
  margin: 0;
  padding: 17px;
  background-color: #002E33;
  color: #FFF;
}
div.Modal > div.window div.header h1 {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.075em;
  line-height: 11px;
  text-align: center;
  text-transform: uppercase;
}
div.Modal > div.window div.content {
  left: 0;
  right: 0;
  padding: 24px 32px;
}
div.Modal > div.window div.content h1 {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.075em;
  color: #002E33;
  text-align: center;
  text-transform: uppercase;
}
div.Modal > div.window div.content p {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #697588;
  line-height: 18px;
  margin: 0px;
  padding-top: 14px;
}
div.Modal > div.window footer,
div.Modal > div.window div.footer {
  text-align: center;
  border-top: 1px solid #E8E9F0;
  padding: 24px 32px;
}
div.Modal > div.window footer .Button,
div.Modal > div.window div.footer .Button {
  line-height: 12px;
  padding: 11px 16px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
div.Modal > div.window footer .Button:not(:first-child),
div.Modal > div.window div.footer .Button:not(:first-child) {
  margin-left: 15px;
}

div.FreeTextInput {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
  border: 1px solid #E8E9F0;
  border-radius: 3px;
  padding: 0px;
  width: 100%;
}
div.FreeTextInput > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
div.FreeTextInput > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
div.FreeTextInput > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
div.FreeTextInput div.freeTextControl div.dropdown {
  position: absolute;
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: 12px;
  padding: 8px 12px;
  right: 0px;
}
div.FreeTextInput div.freeTextControl div.dropdown.menuopen {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
  background-size: 12px;
}
div.FreeTextInput div.freeTextControl.focus {
  border: 1px solid #01FF94;
}
div.FreeTextInput div.freeTextControl textarea {
  width: 100% !important;
  margin-left: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: "Aeonik", sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: #697588;
  resize: none;
  border: none !important;
  padding: 0px;
}
div.FreeTextInput div.freeTextControl textarea:focus {
  border: none !important;
}
div.FreeTextInput div.freeTextControl div.freetext-menu {
  position: absolute;
  z-index: 1000;
  right: -10px;
  top: 25px;
  display: block;
  padding: 8px;
  border-radius: 3px;
  border: 1px solid #F5F6F9;
  background-color: #FFF;
  -webkit-box-shadow: 2px 2px 2px #697588;
          box-shadow: 2px 2px 2px #697588;
}
div.FreeTextInput div.freeTextControl div.freetext-menu > div.btn {
  border-radius: 0;
  display: block;
}
div.FreeTextInput div.freeTextControl div.freetext-menu:after,
div.FreeTextInput div.freeTextControl div.freetext-menu:before {
  content: " ";
  position: absolute;
  display: block;
  width: 0;
  top: -8px;
  right: 9px;
  z-index: 2;
  bottom: auto;
  border-style: solid;
  border-width: 0 8px 8px;
  border-color: #FFF transparent;
}
div.FreeTextInput div.freeTextControl div.freetext-menu:before {
  top: -9px;
  z-index: 1;
  border-bottom-color: #F5F6F9;
}
div.FreeTextInput div.selectButton, div.FreeTextInput div.saveButton {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  color: #002E33;
  font-weight: 700;
  padding: 8px;
}
div.FreeTextInput.focused div.Button {
  opacity: 0.3;
}
div.FreeTextInput.focused div.Button:hover {
  opacity: 1;
}
div.FreeTextInput div.Modal div.select-header {
  top: 0;
  font-size: 16px;
  font-weight: 700;
  margin-top: 0;
  padding-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  text-align: center;
  background-color: #002E33;
  color: #FFF;
}
div.FreeTextInput div.Modal div.selections {
  border: 1px solid #D3D6DF;
  margin: 16px;
}
div.FreeTextInput div.Modal div.selectionRow {
  display: block;
  cursor: pointer;
  padding: 16px;
  border-bottom: 1px solid #D3D6DF;
}
div.FreeTextInput div.Modal div.selectionRow:last-child {
  border-bottom: none;
}
div.FreeTextInput div.Modal div.selectionRow div.selection {
  display: inline-block;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 18px);
}
div.FreeTextInput div.Modal div.selectionRow:hover {
  background-color: #F5F6F9;
}
div.FreeTextInput div.Modal div.selectionRow span.delete {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
  width: 12px;
  padding-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Modal/Modal.scss","webpack://./src/client/components/common/FreeTextInput/FreeTextInput.scss","webpack://./src/client/Global/Colors.scss","webpack://./src/client/Global/InputBase.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,QAAA;EACA,mCAAA;UAAA,2BAAA;ACDF;;ADmGE;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wCAAA;EACA,aAAA;AChGJ;ADmGE;EAvGA,SAAA;EACA,QAAA;EACA,mCAAA;UAAA,2BAAA;EA0HE,sBE9HI;EF+HJ,eAAA;EACA,6BAAA;EACA,WAAA;EACA,uCAAA;UAAA,+BAAA;EACA,cAAA;EACA,aAAA;AClHJ;AD0FI;EACE,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;ACxFN;AD0FM;EACE,aAAA;ACxFR;AD2FM;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,gBE1HA;ADiCR;ADqGI;EACE,aAAA;EACA,yBAAA;ACnGN;ADsGI;EACE,YAAA;EACA,uBAAA;ACpGN;ADuGI;EACE,YAAA;EACA,uBAAA;ACrGN;ADwGI;EACE,YAAA;EACA,uBAAA;ACtGN;ADyGI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,2EAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;UAAA,gBAAA;EACA,WEpKE;EFqKF,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;ACvGN;AD0GI;EAtKF,SAAA;EACA,aAAA;EACA,yBEhBa;EFiBb,WEXM;AD0ER;AD7DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AC+DJ;AD+FI;EAzJF,OAAA;EACA,QAAA;EACA,kBAAA;AC6DF;AD3DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cExCW;EFyCX,kBAAA;EACA,yBAAA;AC6DJ;AD1DE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cEEK;EFDL,iBAAA;EACA,WAAA;EACA,iBAAA;AC4DJ;AD4EI;;EAnIF,kBAAA;EACA,6BAAA;EACA,kBAAA;AC2DF;ADzDE;;EACE,iBAAA;EACA,kBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AC4DJ;AD1DI;;EACE,iBAAA;AC6DN;;AA9HA;EEgBE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cDvBa;EDIX,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAsIJ;AEpHE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cDZa;ECab,gBAAA;EACA,mBAAA;AF4IF;AE7HE;EACE,UA9BS;EA+BT,gBA/BS;AF8Jb;AE5HE;EACE,kBAAA;AF8HJ;AAvJI;EACE,kBAAA;EACA,qBAAA;EACA,oEAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;AAyJN;AAvJM;EACE,oEAAA;EACA,qBAAA;AAyJR;AArJI;EACE,yBAAA;AAuJN;AApJI;EACE,sBAAA;EACA,cAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cCgBG;EDfH,YAAA;EACA,uBAAA;EACA,YAAA;AAsJN;AAnJI;EACE,uBAAA;AAqJN;AAlJI;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBChDE;EDiDF,uCAAA;UAAA,+BAAA;AAoJN;AAlJM;EACE,gBAAA;EACA,cAAA;AAoJR;AAhJI;;EAEE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AAkJN;AA/II;EACE,SAAA;EACA,UAAA;EACA,4BCzBG;AD0KT;AA7IE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cC1FW;ED2FX,gBAAA;EACA,YAAA;AA+IJ;AA3II;EACE,YAAA;AA6IN;AA3IM;EACE,UAAA;AA6IR;AAvII;EACE,MAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBCnHS;EDoHT,WC9GE;ADuPR;AAtII;EACE,yBAAA;EACA,YAAA;AAwIN;AArII;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;AAuIN;AArIM;EACE,mBAAA;AAuIR;AApIM;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AAsIR;AAnIM;EACE,yBCxFC;AD6NT;AAlIM;EACE,oEAAA;EACA,WAAA;EACA,kBAAA;AAoIR","sourcesContent":["@import \"../../../Global/Colors.scss\";\n\ndiv.Modal>div.window {\n  border: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n\n@mixin modalWindowRules {\n  border: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n@mixin headerRules {\n  margin: 0;\n  padding: 17px;\n  background-color: $DeepSeaGreen;\n  color: $White;\n\n  h1 {\n    margin: 0;\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.075em;\n    line-height: 11px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n}\n\n@mixin contentRules {\n  left: 0;\n  right: 0;\n  padding: 24px 32px;\n\n  h1 {\n    margin: 0;\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.075em;\n    color: $DeepSeaGreen;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  p {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 500;\n    color: $Gray90;\n    line-height: 18px;\n    margin: 0px;\n    padding-top: 14px;\n  }\n}\n\n@mixin footerRules {\n  text-align: center;\n  border-top: 1px solid $Gray30;\n  padding: 24px 32px;\n\n  .Button {\n    line-height: 12px;\n    padding: 11px 16px;\n    width: fit-content;\n\n    &:not(:first-child) {\n      margin-left: 15px;\n    }\n  }\n}\n\n@mixin checkboxRules {\n  margin-top: 24px;\n  margin-bottom: 0px;\n\n  >div.check {\n    border-radius: 2px;\n    margin-top: 0px;\n    cursor: pointer;\n  }\n\n  >div.check.checked {\n    background: $ElectricGreen url(\"~images/checkmark_deepSeaGreen.svg\");\n    border: 1px solid $ElectricGreen;\n    background-size: 8px 6px;\n    background-repeat: no-repeat;\n    background-position: 2px 3px;\n  }\n\n  >span.Label {\n    display: inline;\n    position: inherit;\n    color: $DeepSeaGreen;\n    font-weight: 500;\n    font-size: 12px;\n  }\n}\n\ndiv.Modal {\n\n  >div.overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba($Gray200, 0.75);\n    z-index: 3000;\n  }\n\n  >div.window {\n    @include modalWindowRules;\n\n    &.fullscreen {\n      width: 100% !important;\n      left: 0 !important;\n      height: 100% !important;\n      max-height: 100% !important;\n\n      content {\n        height: calc(100vh);\n      }\n\n      footer {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n        background: $White;\n      }\n    }\n\n    background-color: $White;\n    position: fixed;\n    max-height: calc(100% - 20px);\n    right: auto;\n    box-shadow: 2px 2px 5px $shadowColor;\n    overflow: auto;\n    z-index: 3001;\n\n    &.extra-wide {\n      width: 1167px;\n      left: calc(50% - 583.5px);\n    }\n\n    &.wide {\n      width: 900px;\n      left: calc(50% - 450px);\n    }\n\n    &.medium {\n      width: 650px;\n      left: calc(50% - 325px);\n    }\n\n    &.small {\n      width: 400px;\n      left: calc(50% - 200px);\n    }\n\n    a.Button.close {\n      top: 10px;\n      right: 10px;\n      position: absolute;\n      background: url(\"~images/close_modal_White.svg\") center center no-repeat;\n      background-size: 20px;\n      height: 20px;\n      width: 20px;\n      border: none;\n      box-shadow: none;\n      color: $White;\n      padding: 0;\n      margin: 0;\n      font-weight: 700;\n      font-size: 13px;\n      font-family: sans-serif;\n      z-index: 1010;\n      cursor: pointer;\n    }\n\n    div.header {\n      @include headerRules;\n    }\n\n    div.content {\n      @include contentRules;\n    }\n\n    footer,\n    div.footer {\n      @include footerRules;\n    }\n  }\n\n}\n","@import \"../../../Global/InputBase\";\n@import \"../../../Global/Colors.scss\";\n@import \"../Modal/Modal.scss\";\n\ndiv.FreeTextInput {\n  @include inputContainerRules;\n    border: 1px solid $Gray30;\n    border-radius: 3px;\n    padding: 0px;\n    width: 100%;\n\n  div.freeTextControl {\n    div.dropdown {\n      position: absolute;\n      display:inline-block;\n      background: url(FreeTextDropdown.svg) no-repeat center;\n      background-size: 12px;\n      padding: 8px 12px;\n      right: 0px;\n\n      &.menuopen {\n        background: url(FreeTextDropdownActive.svg) no-repeat center;\n        background-size: 12px;\n      }\n    }\n\n    &.focus {\n      border: 1px solid $ElectricGreen;\n    }\n\n    textarea {\n      width: calc(100%) !important;\n      margin-left: 0;\n      box-sizing: border-box;\n      font-family: \"Aeonik\", sans-serif;\n      font-size: 12px;\n      line-height: 16px;\n      color: $Gray90;\n      resize: none;\n      border: none !important;\n      padding: 0px;\n    }\n\n    textarea:focus {\n      border: none !important;\n    }\n\n    div.freetext-menu {\n      position: absolute;\n      z-index: 1000;\n      right: -10px;\n      top: 25px;\n      display: block;\n      padding: 8px;\n      border-radius: 3px;\n      border: 1px solid $Gray20;\n      background-color: $White;\n      box-shadow: 2px 2px 2px $Gray90;\n\n      > div.btn {\n        border-radius: 0;\n        display: block;\n      }\n    }\n\n    div.freetext-menu:after,\n    div.freetext-menu:before {\n      content: \"\\0020\";\n      position:absolute;\n      display:block;\n      width:0;\n      top:-8px;\n      right:9px;\n      z-index:2;\n      bottom:auto;\n      border-style:solid;\n      border-width:0 8px 8px;\n      border-color: $White transparent;\n    }\n\n    div.freetext-menu:before {\n      top:-9px;\n      z-index:1;\n      border-bottom-color:$Gray20;\n    }\n  }\n\n  div.selectButton, div.saveButton {\n    display: block;\n    position: relative;\n    cursor: pointer;\n    font-size: 12px;\n    color: $DeepSeaGreen;\n    font-weight: 700;\n    padding: 8px;\n  }\n\n  &.focused {\n    div.Button {\n      opacity: .3;\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  div.Modal {\n    div.select-header {\n      top: 0;\n      font-size: 16px;\n      font-weight: 700;\n      margin-top: 0;\n      padding-top: 16px;\n      padding-bottom: 16px;\n      margin-bottom: 16px;\n      text-align: center;\n      background-color: $DeepSeaGreen;\n      color: $White;\n    }\n\n    div.selections {\n      border: 1px solid $Gray50;\n      margin: 16px;\n    }\n\n    div.selectionRow {\n      display: block;\n      cursor: pointer;\n      padding: 16px;\n      border-bottom: 1px solid $Gray50;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      div.selection {\n        display: inline-block;\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: calc(100% - 18px);\n      }\n\n      &:hover {\n        background-color: $Gray20;\n      }\n\n      span.delete {\n        background: url(FreeTextCross.png) no-repeat center;\n        width: 12px;\n        padding-left: 16px;\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n","@import '../Global/Colors';\n$inputHeight: 32px;\n$inputWidth: 50%;\n\n\n@mixin inputLabelRules {\n  position: absolute;\n  width: $inputWidth;\n  text-overflow: ellipsis;\n  height: 100%;\n  box-sizing: border-box;\n  line-height: $inputHeight;\n  font-weight: 700;\n  font-size: 12px;\n  color: $DeepSeaGreen;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@mixin inputContainerRules {\n  display: block;\n  margin: 8px 0;\n  position: relative;\n  width: 100%;\n  height: $inputHeight;\n  color: $DeepSeaGreen;\n\n  > span.Label {\n    @include inputLabelRules;\n  }\n\n  > span.Label + .Controlled {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n  }\n\n  > span.Label + .Controlled.CheckBoxInput {\n    margin-left: 225px;\n  }\n}\n\n@mixin inputInputRules {\n  height: 100%;\n  width: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  font-family: \"Aeonik\", sans-serif;\n  border: 1px solid $Gray50;\n  padding: 4px;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $DeepSeaGreen;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
